import { client } from '@/lib/api/client'
import { MANAGED_VENUES_PATH } from '@/lib/api/config'
import { toApiError } from '@/lib/api/errors'

import type { ManagedVenueListView } from './managerVenueTypes'

/**
 * `GET /venue/v1/manager/venues` — 내 구장 컨텍스트 (#584 §1).
 *
 * 🚨 관리자 표면에서 **경로 변수가 없는 유일한 EP** 다. `venueId` 를 모르는 상태에서 부르는
 * 입구이기 때문이며, 두 이용권이 모두 만료돼도 **항상 200** 이다(게이팅 대상 아님).
 * 🚨 연결 구장이 0건이면 에러가 아니라 `venues: []` 다 — 빈 목록을 실패로 처리하지 말 것.
 */
export async function fetchManagedVenues(): Promise<ManagedVenueListView> {
  try {
    const { data } = await client.get<ManagedVenueListView>(MANAGED_VENUES_PATH)
    return data
  } catch (error) {
    throw toApiError(error)
  }
}
